var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Payments',{attrs:{"id":_vm.orgId,"isProvider":_vm.isProvider,"productCode":_vm.productCode,"returnRoute":_vm.returnRoute},on:{"cancelled":_vm.handleCancelled,"error":_vm.handleError,"submitted":_vm.handleSubmitted,"success":_vm.handleSuccess}})
}
var staticRenderFns = []

export { render, staticRenderFns }